import { Screen } from '~/screens/Branches/[id]/edit';

export const BranchEdit: React.FC = () => <Screen />;
